// extracted by mini-css-extract-plugin
export default {"mainWrapper":"AdminAddNewPage_mainWrapper__DhyL+","mainContainer":"AdminAddNewPage_mainContainer__aQt-b","mainBox":"AdminAddNewPage_mainBox__uCHY-"};